<template>
  <div class="products pt-15">
    <v-container fluid>
      <h3 class="text-pro">Shop products</h3>
      <a
        href="#"
        class="text-black pt-5 pb-15"
        style="font-size: 14px; text-align: end; display: block"
        >Shop All</a
      >

      <v-col cols="12" v-if="!allData.length">
        <v-row>
          <v-col cols="3" v-for="num in 4" :key="num">
            <v-skeleton-loader type="image, article"> </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
      <swiper
        v-else
        :slides-per-view="5"
        :space-between="30"
        :pagination="{ clickable: true }"
        :modules="modules"
        :navigation="true"
        class="mySwiper pb-5"
        style="padding-top: 10px"
        :autoplay="{
          delay: 3000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }"
        :breakpoints="breakpoints"
        :loop="true"
      >
        <swiper-slide v-for="item in allData" :key="item.id">
          <v-card elevation="0" class="pb-10 card-producte">
            <div class="master-btn text-center" style="position: relative">
              <img
                :src="
                  showImgData[item.title]
                    ? showImgData[item.title]
                    : item.thumbnail
                "
                class="w-100 imge-swiper"
                style="height: 180px"
                alt=""
              />
              <div
                style="
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  cursor: pointer;
                  width: 20px;
                  height: 20px;
                "
              >
                <v-icon
                  :style="`color:${item.wishlist ? 'red' : 'red'}`"
                  @click="item.wishlist = !item.wishlist"
                  size="20"
                >
                  {{ item.wishlist ? "mdi-heart" : "mdi-heart-outline" }}
                </v-icon>
              </div>

              <v-btn
                @click="openView(item)"
                density="compact"
                width="60"
                height="30"
                variant="outlined"
                class="bg-white quick-viewF"
              >
                Quick View
              </v-btn>
            </div>

            <v-card-text class="pa-0">
              <span style="font-weight: bold"
                >(
                {{
                  item.title.split(" ").length > 3
                    ? item.title.split(" ").slice(0, 3).join(" ")
                    : item.title
                }}
                )</span
              >
              {{
                item.description.length <= 30
                  ? ` ${item.description}`
                  : ` ${item.description.slice(0, 30)}...`
              }}
            </v-card-text>
            <v-rating
              v-model="item.rating"
              half-increments
              readonly
              color="yellow-darken-2"
              size="x-small"
              density="compact"
            ></v-rating>
            <v-card-text class="pt-0">
              <del class="mr-1" style="opacity: 0.5">{{ item.price }}</del>
              <span style="font-weight: 700; margin-right: 2px">From</span>
              <span style="font-size: 16px; font-weight: 900; color: #ff0000">
                {{
                  Math.ceil(
                    item.price - item.price * (item.discountPercentage / 100)
                  )
                }}$
              </span>
            </v-card-text>
            <v-btn-toggle v-model="showImgData[item.title]" divided>
              <v-btn
                v-for="(pic, i) in item.images"
                :value="pic"
                :key="i"
                size="x-small"
              >
                <img
                  :src="pic"
                  alt=""
                  width="30"
                  height="30"
                  style="border-radius: 50%; border: 1px solid #d9d9d9"
                />
              </v-btn>
            </v-btn-toggle>
            <div class="mt-5 btn-Options">
              <v-btn
                @click="
                  router.push({
                    name: 'product-detils',
                    params: { productId: item.id },
                    query: { name: 'hossam' },
                  })
                "
                color="red"
                variant="outlined"
                style="
                  text-transform: none;
                  border-radius: 30px;
                  padding: 10px 20px;
                  font-weight: 700;
                  font-size: 13px;
                "
              >
                Choose Options
              </v-btn>
            </div>
          </v-card>
        </swiper-slide>
        <div class="swiper-pagination"></div>
      </swiper>
    </v-container>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, inject, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Autoplay } from "swiper";
import router from "@/router";

const modules = ref([Pagination, Navigation, Autoplay]);
const showImgData = ref({});
const Emitter = inject("Emitter");
const allData = ref([]);
const breakpoints = ref({
  0: {
    slidesPerView: 1,
  },
  580: {
    slidesPerView: 2,
  },
  767: {
    slidesPerView: 3,
  },
  990: {
    slidesPerView: 4,
  },
});

const openView = (productId) => {
  Emitter.emit("openView", productId);
};

// تعريف الخصائص
const props = defineProps({
  products: {
    type: Array,
  },
});

watch(
  () => allData.value,
  () => {
    localStorage.setItem("productsData", JSON.stringify(allData.value));
    Emitter.emit("getLocalStorage");
  },
  { deep: true }
);
watch(
  () => props.products,
  () => {
    allData.value = props.products;
    if (
      localStorage.getItem("productsData") &&
      JSON.parse(localStorage.getItem("productsData")).length
    ) {
      allData.value = JSON.parse(localStorage.getItem("productsData"));
    }
  },
  { deep: true }
);
onMounted(() => {
  allData.value = props.products;
  if (
    localStorage.getItem("productsData") &&
    JSON.parse(localStorage.getItem("productsData")).length
  ) {
    allData.value = JSON.parse(localStorage.getItem("productsData"));
  }
});
</script>

<style lang="css">
.mySwiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.products .swiper-button-next::after,
.products .swiper-button-prev::after {
  font-size: 20px;
  background-color: #2196f3;
  padding: 15px 20px;
  color: white;
  font-weight: 900;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.products .text-pro {
  font-weight: 800;
  background: linear-gradient(65deg, #1f0dff, #67d767, #ff0000);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 30px;
  justify-content: center;
}
.master-btn .quick-viewF {
  text-transform: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 30px;
  font-size: 12px;
  transition: 0.2s all ease-in-out;
  opacity: 0;
}
.master-btn:hover .quick-viewF {
  opacity: 1;
}
@media (max-width: 480px) {
  .products .master-btn .imge-swiper {
    width: 220px !important;
  }
  .products .btn-Options {
    text-align: center;
  }
  .products .card-producte {
    text-align: center;
  }
  .products .text-pro {
    font-size: 20px;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  .products .master-btn .imge-swiper {
    width: 220px !important;
  }
  .products .btn-Options {
    text-align: center;
  }
  .products .card-producte {
    text-align: center;
  }
}
</style>
